export default {
  save: 'Save',
  reset: 'Reset',
  close: 'Close',
  create: 'Create',
  delete: 'Delete',
  ok: 'OK',
  search: 'Search',
  yes: 'Yes',
  no: 'No',
  price: 'Price',
  city: 'City',
  language: 'Language',
  selectedDate: 'Selected Date',
  selectedDateRange: 'Selected Date Range',
  discardChanges: 'Discard Changes?',
  discardChangesBody: 'There are unsaved changes. Are you sure you want to close without saving?',
  discardChangesBodyContinue: 'There are unsaved changes. Are you sure you want to continue without saving?',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  required: 'Required',
  tooFew: 'Too Few',
  count: 'Count',
  confirm: 'Confirm',
  cancel: 'Cancel',
  amount: 'Amount',
  comment: 'Note',
  newCashEntry: 'New Cash Entry',
  invalidFields: 'Form contains incorrect field(s): {fields}',
  balanceNotSufficient: 'Balance not sufficient',
  'forMonth-0': 'January',
  'forMonth-1': 'February',
  'forMonth-2': 'March',
  'forMonth-3': 'April',
  'forMonth-4': 'May',
  'forMonth-5': 'June',
  'forMonth-6': 'July',
  'forMonth-7': 'August',
  'forMonth-8': 'September',
  'forMonth-9': 'October',
  'forMonth-10': 'November',
  'forMonth-11': 'December',
  'forDay-1': 'Monday',
  'forDay-2': 'Tuesday',
  'forDay-3': 'Wednesday',
  'forDay-4': 'Thursday',
  'forDay-5': 'Friday',
  'forDay-monday': 'Monday',
  'forDay-tuesday': 'Tuesday',
  'forDay-wednesday': 'Wednesday',
  'forDay-thursday': 'Thursday',
  'forDay-friday': 'Friday',
};
